import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import {
  createYourDetailsSlice,
  YourDetailsSlice,
} from './storeSlices/yourDetails';
import {
  createUploadPhotoSlice,
  UploadPhotoSlice,
} from './storeSlices/uploadPhoto';
import {
  WasteDetailsSlice,
  createWasteDetailsSlice,
} from './storeSlices/wasteDetails';

export const useWasteStore = create<
  YourDetailsSlice & UploadPhotoSlice & WasteDetailsSlice
>()(
  persist(
    (...a) => ({
      ...createYourDetailsSlice(...a),
      ...createUploadPhotoSlice(...a),
      ...createWasteDetailsSlice(...a),
    }),
    {
      name: 'waste-details-storage', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
